import { render, staticRenderFns } from "./ConfigDirectMatchGeneralProperties.vue?vue&type=template&id=0de9a3a2&scoped=true&"
import script from "./ConfigDirectMatchGeneralProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigDirectMatchGeneralProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDirectMatchGeneralProperties.vue?vue&type=style&index=0&id=0de9a3a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9a3a2",
  null
  
)

export default component.exports